import React from 'react';
import Immutable from 'immutable';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import WebformActions from '@uncinc/react-drupal-core/dist/Components/Webform/WebformActions';
import WebformHidden from '../../../components/Webform/Hidden';
import { WebformWrapper } from '../../../components';

import './style.scss';

// Custom webform actions to always add required icon classes.
const CustomWebformActions = (props) => {
  let { entity } = props;
  const classnamesToAdd = ['icon-after', 'icon--arrow-right', 'icon-variant-2'];

  if (entity.hasIn(['#submit__attributes', 'class'])) {
    entity = entity.setIn(['#submit__attributes', 'class'], entity.getIn(['#submit__attributes', 'class']).merge(Immutable.fromJS(classnamesToAdd)));
  } else {
    entity = entity.setIn(['#submit__attributes', 'class'], Immutable.fromJS(classnamesToAdd));
  }

  return <WebformActions {...props} entity={entity} />;
};

const ParagraphFeedback = ({ entity }) => {
  const webform = entity.getIn(['field_webform', 0, 'target_id']);

  return (
    <Container className="Paragraph ParagraphFeedback">
      <div className="row">
        <div className="col-12 col-md-12 col-lg-10 offset-lg-1">
          <div className="ParagraphFeedback__inner">
            {webform && webform !== 'webform_' && (
              <WebformWrapper id={webform} overriddenComponents={{ webform_actions: CustomWebformActions, hidden: WebformHidden }} />
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphFeedback;
